import { faComment, faHeart, faRetweet } from '@fortawesome/pro-solid-svg-icons'
import { Card, CardHeader, Stack } from '@mui/material'
import { memo } from 'react'

import DisplayBadge from '../membership/DisplayBadge'
import FaIcon from 'src/components/shared/faIcon/FaIcon'
import Text from '../shared/text/Text'

const EarnEngagement = ({ t, symbol }) => {
  const data = [
    {
      label: 'likes',
      icon: faHeart,
      points: 1,
      count: 3
    },
    {
      label: 'comments',
      icon: faComment,
      points: 2,
      count: 1
    },
    {
      label: 'reposts',
      icon: faRetweet,
      points: 3,
      count: 1
    }
  ]
  return (
    <Card sx={{ p: 3 }}>
      <CardHeader
        title={t('earn-via.earn-engagement')}
        subheader={t('earn-via.earn-engagement-desc', { symbol })}
        sx={{ p: 0 }}
      />
      <Stack spacing={1} mt={2}>
        {data.map(({ label, icon, points, count }) => (
          <Stack key={label} direction='row' justifyContent='space-between'>
            <DisplayBadge
              name={t(`earn-via.${label}`)}
              size='xs'
              direction='row'
              icon={<FaIcon icon={icon} style={{ fontSize: 20 }} />}
              iconStyles={{
                backgroundColor: 'transparent',
                border: 'none',
                color: 'revert'
              }}
            />
            <Text
              label={`${points} ${symbol} / ${t(`earn-via.${label}-count`, { count })}`}
            />
          </Stack>
        ))}
      </Stack>
    </Card>
  )
}

export default memo(EarnEngagement)
